import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CampaignExtendedNameDto } from '@pages/Traders-Room/Trading-Accounts/NewTradingAccount/CreateTradingAccountCampaign.types'

import { BaseModalType, useModal } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'
import { RadioProps } from '@ui/components/Radio'

import { CampaignAccountConfirmationModal } from '@shared/components/Navigation/modals/CampaignAccountConfirmation.modal'

interface Props {
  campaigns: CampaignExtendedNameDto[]
  isCampaign?: boolean
  initialValue?: string
  onSelect: (value: CampaignExtendedNameDto) => void
}

export const RegularCampaignAccountTypeModal: BaseModalType<Props> = (props) => {
  const { close, campaigns, isCampaign, initialValue, onSelect } = props
  const { t } = useTranslation()
  const campaignAccountConfirmationModal = useModal(CampaignAccountConfirmationModal, {
    variant: 'informational',
  })

  const campaignOptions = useMemo(() => {
    return campaigns
      .filter((campaign) => (isCampaign ? campaign.id !== '0' : true))
      .map(
        (campaign) =>
          ({
            label: campaign.name,
            value: campaign.id,
          } as RadioProps)
      )
  }, [campaigns, isCampaign])

  const handleSelection = (selectedId: string) => {
    const selectedCampaign = campaigns.find((c) => c.id === selectedId)
    if (selectedCampaign) {
      onSelect(selectedCampaign)
      if (selectedCampaign.isCampaign) {
        campaignAccountConfirmationModal.open()
      }
    }
    close()
  }

  return (
    <Modal>
      <Modal.Header>{t('Trading Account.Account Type')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Input.Radio
          value={initialValue}
          name='campaign-account-type-radio'
          options={campaignOptions}
          onChange={handleSelection}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
